import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@design-system/';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  height: 500px;

  .image {
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
  }
`;

export const EmptyState = ({ icon, title, text, ...props }) => {
  return (
    <Container>
      <div>
        <div className="image">
          <img src={icon} alt={icon} />
        </div>

        <Text size="large" align="center" {...props} color="#333333">
          {title}
        </Text>
        <Text size="small" align="center" {...props} color="#828282">
          {text}
        </Text>
      </div>
    </Container>
  );
};

EmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  icon: PropTypes.string,
};

EmptyState.defaultProps = {
  icon: '',
};

export default EmptyState;
